//export const BASE_URL = process.env.NODE_ENV === 'development' ? 'http://localhost:5000' : '';
export const BASE_URL='';
export const PRODUCTS_URL = '/api/products';
export const USERS_URL ='/api/users';
export const ORDERS_URL = '/api/orders';
export const PAYPAL_URL = '/api/config/paypal';
export const UPLOAD_URL= '/api/upload';
export const OBJECTS_URL = '/api/objects';

// Kablo ürünleri metre bazında satılıyor. Kategoriye göre minimum sipariş
// miktarı ve sonraki artış adımı (katı) farklıdır:
// - Sinyal ve Kontrol Kabloları: min 50 metre, sonrasında 15'in katları (50, 65, 80, ...)
// - Kumanda Kablosu: min 15 metre, 15'in katları (15, 30, 45, ...)
export const CABLE_CATEGORY_RULES = {
    'Sinyal ve Kontrol Kabloları': { min: 50, step: 15 },
    'Kumanda Kablosu': { min: 15, step: 15 },
};
export const CABLE_CATEGORIES = Object.keys(CABLE_CATEGORY_RULES);
export const isCableCategory = (category) => Object.prototype.hasOwnProperty.call(CABLE_CATEGORY_RULES, category);
export const getCableMinQty = (category) => CABLE_CATEGORY_RULES[category]?.min ?? 1;

// Kablo miktar <select> seçeneklerini üretir: min'den başlayıp step artışlarıyla
// stok miktarına kadar çıkar. Stok min'in altındaysa tek seçenek olarak stok sunulur.
export const getCableQtyOptions = (category, countInStock) => {
    const rule = CABLE_CATEGORY_RULES[category];
    if (!rule) return null;
    const { min, step } = rule;
    if (countInStock < min) return [countInStock];
    const options = [];
    for (let q = min; q <= countInStock; q += step) {
        options.push(q);
    }
    return options;
};
